import { Link, Navigate } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center pt-24">
        <Loader2 className="h-8 w-8 animate-spin text-navy" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  if (adminOnly && !["admin", "member"].includes(user.role)) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center px-5 pt-24 text-center">
        <ShieldAlert className="h-10 w-10 text-gold" />
        <h1 className="mt-6 font-heading text-2xl font-bold text-ink">Admin access required</h1>
        <p className="mt-2 text-sm text-fog">
          This area is restricted to Sunkev Enterprises administrators.
        </p>
        <Link
          to="/"
          className="mt-8 rounded-full bg-navy px-8 py-3 font-heading text-xs font-bold uppercase tracking-widest text-white"
        >
          Back to Home
        </Link>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
